<script>
  import _debounce from 'lodash/debounce'
  export default {
    props: {
      value: {
        type: String,
        default: ''
      },
      title: {
        type: String,
        default: ''
      },
      type: {
        type: String,
        default: 'prompt',
        validator(value) {
          return [
            'prompt',
            'click',
          ].includes(value)
        },
      },
      list: {
        type: Array,
        default: () => {
          return []
        }
      },
    },
    data() {
      return {

      }
    },
    computed: {
      data: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        },
      },

    },
    methods: {
      onChangeOrderBy: _debounce(function () {
        this.$emit('input', this.data);
        if(this.type === 'prompt') {
          this.$emit('changeOrderBy', this.data);
        }
      }, 600),
    }
  }
</script>
<template>
  <div :class="$style.BaseStatus">
    <div class="baseStatus__title">{{ title }}</div>
    <el-select 
      v-model="data" 
      placeholder="請選擇" 
      class="isStyleMenu w-100"
      clearable
      @change="onChangeOrderBy"
    >
      <el-option
        v-for="item in list"
        :key="item.value"
        :label="item.text"
        :value="item.value">
      </el-option>
    </el-select>
  </div>
</template>
<style lang="scss" module>
.BaseStatus {
  :global {
    .baseStatus {
      &__title {
        padding-bottom: 1.8rem;
        font-size: 1.5rem;
        font-weight: 500;
        cursor: pointer;
        @include max-lg {
          display: none;
        }
        @include max-md {
          display: block;
          padding-bottom: 1rem;
          font-size: 1.125rem;
        }
      }
    }
  }
  
}
</style>
